import script from "./ContainerBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContainerBox.vue?vue&type=script&lang=ts&setup=true"

import "./ContainerBox.vue?vue&type=style&index=0&id=64f84e6c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64f84e6c"]])

export default __exports__